module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-5714db3693139dc59b015d7119ebf88a.svg";